import _extends from "@babel/runtime/helpers/extends";
import { BlockerGroupsInlineStyles } from ".";
import { useBlocker } from "../../contexts";
import { isUrl } from "../../utils";

var BlockerCookieProperty = function BlockerCookieProperty(_ref) {
  var label = _ref.label,
      value = _ref.value,
      children = _ref.children;
  var blocker = useBlocker();
  var isValueUrl = typeof value === "string" && isUrl(value);
  var useValue = isValueUrl ? h("a", _extends({
    href: value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, BlockerGroupsInlineStyles.linkMore(blocker, false)), value) : value;
  return h("div", _extends({
    key: label
  }, BlockerGroupsInlineStyles.cookieProperty(blocker)), h("strong", null, label, ":\xA0"), h("span", {
    style: {
      lineBreak: isValueUrl ? "anywhere" : undefined
    }
  }, useValue), !!children && h("div", null, children));
};

export { BlockerCookieProperty };